export type QuestionnaireKind = 'questionnaire' | 'therapy-material' | 'nachsorge';

export const isTherapyMaterialKind = (kind: QuestionnaireKind): boolean => kind === 'therapy-material';

export const isNachsorgeKind = (kind: QuestionnaireKind): boolean => kind === 'nachsorge';

export const usesEmbeddedMaterialRenderer = (kind: QuestionnaireKind): boolean =>
    isTherapyMaterialKind(kind) || isNachsorgeKind(kind);
